<template>
  <div>
    <AlterFormLayout modalId="income-history-modal" formTitle="Calendário de entregas de Notas Fiscais"
      cancelButtonText="Fechar" submitButtonText="Baixar calendário em PDF" :onSubmitEvent="downloadPdf"
      :disableValidation="true" :landscape="true">
      <template #content>
        <pdf-viewer :landscape="true" :getDocumentHandler="getDocumentHandler" height="60vh" />
      </template>
    </AlterFormLayout>
  </div>
</template>

<script>
import PdfViewer from "../../../components/pdf-viewer/PdfViewer.vue";
import AlterFormLayout from "../../../layouts/AlterFormLayout.vue";
import { anchorBase64Download } from "../../../utils/anchor-base64-download/anchor-base64-download";
import {
  getDocumentsTypes,
  getListDocuments,
} from "../../../services/documents_atas/documents-atas";

import { arrayBufferToBase64 } from "../../../utils/File/fileHelper";
export default {
  props: ["competencyDate"],
  data() {
    return {
      downloadedFile: null,
      fileUrl: null,
    };
  },
  components: {
    AlterFormLayout,
    PdfViewer,
  },
  methods: {
    downloadPdf() {
      if (!this.downloadedFile) return;
      anchorBase64Download(
        this.$store.getters.isApp,
        "application/pdf",
        "calendario-entrega-notas-fiscais.pdf",
        this.downloadedFile,
      );
    },
    async getDocumentHandler() {
      const download = await this.downloadFile();
      this.downloadedFile = download;
      const binaryString = atob(download);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    },
    async downloadFile() {
      try {
        const typeDocument = await this.obterTipoDocumento();

        const documento = typeDocument.find(
          (item) => item.year === this.competencyDate.year,
        );

        this.fileUrl = documento?.download?.pathFile ?? null;

        const base64Gerado = await arrayBufferToBase64(this.fileUrl);

        return base64Gerado.base64;
      } catch (error) {
        console.error("Error on function downloadFile:", error);
      }
    },
    async obterTipoDocumento() {
      const list = await getDocumentsTypes();

      const documentoEncontrado = list.find(
        (item) => item.type === "Cronograma de Liberação das Analíticas e Envio da Nota Fiscal",
      );

      const items = await getListDocuments(documentoEncontrado.id);
      const dataFile = this.requestHistoryMapper(items);

      return dataFile;
    },
    requestHistoryMapper(documents) {
      let requests = [];
      documents.forEach((document) => {
        requests.push({
          name: document.name,
          year: document.year,
          download: document.download,
        });
      });

      return requests;
    },
  },
};
</script>
